function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { variables } from 'swag-client-common/styles/variables-js';
export const labelStyleCommon = {
  boxSizing: 'border-box',
  margin: 0,
  lineHeight: 'initial',
  top: 0,
  display: 'flex',
  justifyContent: 'start',
  paddingLeft: '1.5em',
  alignItems: 'center'
};
export const pickerStyles = {
  style: {
    backgroundColor: variables.colorBackgroundLightGray,
    boxSizing: 'border-box',
    height: 'inherit'
  },
  menuStyle: {
    backgroundColor: variables.colorBackgroundLightGray,
    boxSizing: 'border-box'
  },
  underlineStyle: {
    display: 'none'
  },
  labelStyle: {
    boxSizing: 'border-box',
    margin: 0,
    padding: '1.2em 1.5em',
    lineHeight: 'initial',
    top: 0
  },
  labelStyleFlexible: _objectSpread({}, labelStyleCommon),
  labelStyleFlexibleBig: _objectSpread({}, labelStyleCommon, {
    height: '66px'
  }),
  iconStyle: {
    right: '1.5em',
    top: '50%',
    transform: 'translateY(-50%)'
  }
};